import React from "react"

export default class HumanTimeSince extends React.Component {
  constructor(props) {
    super(props)
    this.state = this.getState(props.time)
    this.timeoutId = null
  }

  scheduleUpdate = updateDelay => {
    if (updateDelay) {
      this.timeoutId = setTimeout(() => {
        const nextState = this.getState(this.props.time)
        this.setState(nextState)
        this.scheduleUpdate(nextState.updateDelay)
      }, 1000 * updateDelay)
    }
  }

  componentDidMount = () => {
    this.scheduleUpdate(this.state.updateDelay)
  }

  componentDidUpdate = prevProps => {
    if (this.props.time !== prevProps.time) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
        this.timeoutId = null
      }
      const nextState = this.getState(this.props.time)
      this.setState(nextState)
      this.scheduleUpdate(nextState.updateDelay)
    }
  }

  componentWillUnmount = () => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }

  getState = time => {
    const numSeconds = Math.floor((new Date() - new Date(time)) / 1000)

    const numYears = Math.floor(numSeconds / 31536000)
    if (numYears >= 1) {
      return {
        humanTime: numYears + " year" + (numYears > 1 ? "s" : ""),
        updateDelay: null
      }
    }

    const numMonths = Math.floor(numSeconds / 2592000)
    if (numMonths >= 1) {
      return {
        humanTime: numMonths + " month" + (numMonths > 1 ? "s" : ""),
        updateDelay: null
      }
    }

    const numDays = Math.floor(numSeconds / 86400)
    if (numDays >= 1) {
      return {
        humanTime: numDays + " day" + (numDays > 1 ? "s" : ""),
        updateDelay: 86400
      }
    }

    const numHours = Math.floor(numSeconds / 3600)
    if (numHours >= 1) {
      return {
        humanTime: numHours + " hour" + (numHours > 1 ? "s" : ""),
        updateDelay: 3600
      }
    }

    const numMinutes = Math.floor(numSeconds / 60)
    if (numMinutes >= 1) {
      return {
        humanTime: numMinutes + " minute" + (numMinutes > 1 ? "s" : ""),
        updateDelay: 60
      }
    }

    return {
      humanTime: numSeconds + " second" + (numSeconds > 1 ? "s" : ""),
      updateDelay: 1
    }
  }

  render = () => {
    return <span>{this.state.humanTime}</span>
  }
}
